import { Box, Skeleton, Divider } from '@mui/material';

const SalesforceTaskDrawerSkeleton = ({ showCompletedBanner = false }) => (
	<Box
		sx={{
			flex: 1,
			padding: '16px 18px',
		}}
	>

		{showCompletedBanner && (
			<Box
				sx={{
					backgroundColor: 'background.subtle',
					borderRadius: '8px',
					padding: '8px 10px',
					height: '45px',
					mb: 2,
				}}
			/>
		)}
		<Box
			sx={{
				backgroundColor: 'background.subtle',
				borderRadius: '8px',
				padding: '8px 10px',
			}}
		>
			{Array.from({ length: 6 }).map((_, index) => (
				<Box
					key={index}
					sx={{
						display: 'grid',
						gridTemplateColumns: '120px minmax(0, 1fr)',
						gap: '12px',
						alignItems: 'center',
						py: '7px',
					}}
				>
					<Skeleton variant='text' width={70} height={18} />
					<Skeleton
						variant='rounded'
						height={40}
						sx={{ borderRadius: '6px' }}
					/>
				</Box>
			))}

			<Box
				sx={{
					display: 'grid',
					gridTemplateColumns: '120px minmax(0, 1fr)',
					gap: '12px',
					alignItems: 'flex-start',
					py: '7px',
				}}
			>
				<Skeleton variant='text' width={70} height={18} />
				<Skeleton variant='rounded' height={96} sx={{ borderRadius: '6px' }} />
			</Box>
		</Box>

		<Divider sx={{ my: 4 }} />

		{Array.from({ length: 2 }).map((_, index) => (
			<Box
				key={index}
				sx={{
					display: 'grid',
					gridTemplateColumns: '110px minmax(0, 1fr)',
					gap: '12px',
					alignItems: 'flex-start',
					py: '7px',
			    }}
		    >
			<Skeleton variant='text' width={70} height={18} />
			<Skeleton variant='rounded' height={'16px'} width={'200px'} sx={{ borderRadius: '6px' }} />
		    </Box>
		))}
	</Box>
);

export default SalesforceTaskDrawerSkeleton;
